<template>
  <header>
    <nav class="navbar navbar-light mc-topbar fixed-top">
      <div class="container navbar-container">
        <a class="navbar-brand" href="#">
          <div class="logo-brand">
            <div class="ktb-logo">
              <img src="@/resources/img/ktb-logo.png">
            </div>
            <div class="vertical-line"></div>
            <div class="mc-logo">
              <img src="@/resources/img/h_elg.jpg">
            </div>
          </div>
        </a>
        <div class="ml-auto d-flex">
          <div class="mainmenu-btn mr-2 d-none d-sm-block">
            <!-- <b-link :to="'Lgmain'" class="btn btn-secondary-custom white-version shadowed">
                <i class="feather-icon icon-grid"></i>เมนูหลัก
            </b-link> -->

            <a @click="mainpage()" v-show="this.$route.name!=='Disclaimer' && this.$route.name!=='LgSearch' && (this.$route.name!=='changePassword' && this.$store.getters.authStatus!=='successFirst')" class="btn btn-secondary-custom white-version shadowed"  style="cursor:pointer">
              <i class="feather-icon icon-grid"></i>เมนูหลัก
            </a>
          </div>

          <div>
            <button
              class="btn btn-noborder dropdown-toggle"
              type="button"
              id="profile-btn"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="feather-icon icon-user"></i>
              <span>{{name}}</span>
            </button>
            <b-dropdown>
              <b-dropdown-item v-bind:to="'taskList'" v-show="this.$route.name!=='Disclaimer' && this.$route.name!=='LgSearch'">
                <i class="feather-icon icon-list"></i>ยืนยันการขอใช้วงเงิน
              </b-dropdown-item>
              <b-dropdown-item v-bind:to="'taskHistoryList'" v-show="this.$route.name!=='Disclaimer' && this.$route.name!=='LgSearch'">
                <i class="feather-icon icon-list"></i>ประวัติการขอใช้วงเงิน
              </b-dropdown-item>
              <b-dropdown-item v-bind:to="'apphistory'" v-show="this.$route.name!=='Disclaimer' && this.$route.name!=='LgSearch'">
                <i class="feather-icon icon-list"></i>ประวัติการทำรายการ
              </b-dropdown-item>
              <b-dropdown-item v-bind:to="'changePassword'" v-show="this.$route.name!=='Disclaimer'">
                <i class="feather-icon icon-user-check"></i>เปลี่ยนรหัสผ่าน
              </b-dropdown-item>
              <b-dropdown-item @click="logout()">
                <i class="feather-icon icon-log-out"></i>ออกจากระบบ
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <div class="mobile-menu-toggle">
            <button class="btn btn-noborder mobile-menu-btn" type="button" id="mobile-menu-toggle">
              <i class="feather-icon icon-menu"></i>
            </button>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>


<script>
import { AUTH_LOGOUT } from "@/store/actions/auth";

export default {
  name: "appHeader",
  data() {
    return {
      name: ""
    };
  },
  mounted() {
    this.name = localStorage.getItem('user-name')
  },
  methods: {
    logout: function() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        this.$router.push("/");
      });
    },
    mainpage: function() {
      localStorage.setItem("amount","0.00");
      this.$router.push("/lgmain");
    },    
    history: function() {
      this.$router.push("/history");
    },
    taskList: function() {
      this.$router.push("/taskList")
    }
  }
};
</script>
